

import { DEFAULT_WORKING_HOURS } from '@xeetr/types/defaults'
import { ViewEmployee } from '@xeetr/types/models'
import { Plus } from 'lucide-react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'

import LabeledInputNumber from '../../inputs/LabeledInputNumber'

import EmployeeWorkingHourCard from './workinghour/EmployeeWorkingHourCard'

import { Button } from '@/components/ui/button'

const EmployeeWorkingHours = () => {
  const { control } = useFormContext<ViewEmployee>()
  const {
    fields: workingHours,
    append: addWorkingHour,
    remove: removeWorkingHour,
  } = useFieldArray({
    control,
    name: 'workingHours',
  })

  return (
    <section>
      <h3 className="mb-4 text-lg font-semibold">Arbeitszeiten</h3>
      <div className="grid gap-4 md:grid-cols-2">
        <Controller
          control={control}
          name="settings.durationTimeslots"
          render={({ field }) => (
            <div className="w-fit">
              <LabeledInputNumber
                className="w-fit"
                label="Buchungsintervall"
                name={field.name}
                value={field.value}
                inputRef={field.ref}
                onChange={field.onChange}
                suffix="min"
                min={1}
              />
              <p className="text-muted-foreground text-xs">
                In welchem Takt Kund:innen einen Termin beginnen können (z. B. alle 15 Minuten).
              </p>
            </div>
          )}
        />
        <div className="flex justify-end md:col-span-2">
          <Button
            variant="outline"
            onClick={() => addWorkingHour({ ...DEFAULT_WORKING_HOURS, id: uuidv4() })}
          >
            <Plus className="mr-2 h-4 w-4" />
            Neue Arbeitszeit hinzufügen
          </Button>
        </div>
        <div className="flex flex-wrap gap-5 md:col-span-2">
          {workingHours.map((workingHour, workingHourIndex) => (
            <EmployeeWorkingHourCard
              key={workingHour.id}
              workingHourIndex={workingHourIndex}
              onRemove={() => removeWorkingHour(workingHourIndex)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default EmployeeWorkingHours
